module.exports = __webpack_public_path__ + "img/tooltip_02-vallone-noya-01-black.3106614b.jpg";